import { useTranslation } from "react-i18next";

export default function ProductHeader({name = "",description="",title2="",img = "", tansparent=false}) {
    const { t } = useTranslation();
    return (
        <div class="p-5 m-5 max-w-lg bg-white border border-gray-200 rounded-lg shadow-sm bg-opacity-95">

            <h5 class="text-3xl font-bold tracking-tight text-gray-900">{t("change_of_product_tit")}</h5>

            <p class="mb-1 mt-2 font-normal text-xl text-gray-700 whitespace-pre-wrap flex-grow">
                {t("change_of_product")}
            </p>

            <div class="px-4 mb-1 mt-auto">
                <a href="#/contacts" class="flex justify-center w-full px-3 py-2 text-sm font-medium text-center text-white bg-orange-700 rounded-lg hover:bg-orange-800 focus:outline-none">
                    {t("contacts")}
                </a>
            </div>
        </div>
    )
}